import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { UserConfigSchema } from "../../_offline/models/userConfiguration.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class UserConfigurationDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<UserConfigSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.USER_CONFIG.GET_ALL, this.loginUserService.loginUser?.id, this.loginUserService.tenantId);
  }

  putAll(userConfigs: UserConfigSchema[]): Observable<UserConfigSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.USER_CONFIG.PUT_ALL, userConfigs);
  }
}
